module.exports = __webpack_public_path__ + "static/img/trinity-common-use-white.1117faa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trinity-common-use-white.png
// module id = EHON
// module chunks = 0